module.exports = __webpack_public_path__ + "static/media/A18040103_10003_6.f40a1a6c.jpg";